export default __webpack_public_path__ + "assets/Onboarding_Suggestions.jpg";